import firebase from 'firebase'
import config from './firebaseConfig'

firebase.initializeApp(config)

export default firebase
